/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extra_Session_Hint_WeekInputs */

const fr_extra_session_hint_week = /** @type {(inputs: Extra_Session_Hint_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si tu te désinscris, la séance est gardée en réserve et utilisée plus tard, une fois ton quota de la semaine atteint.`)
};

/**

* @param {Extra_Session_Hint_WeekInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_session_hint_week = /** @type {((inputs?: Extra_Session_Hint_WeekInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Session_Hint_WeekInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_session_hint_week(inputs)
});